export default __webpack_public_path__ + "static/media/final_func_vacant.08a8bfef.geojson";